const   assistiveYes = document.getElementById('assistive-yes'),
        assistiveNo = document.getElementById('assistive-no'),
        assistiveTextarea = document.getElementById('assistive-used'),
        assistiveLabel = document.getElementById('free-text-label'),
        interestOther = document.getElementById('interest-other'),
        interestOtherfield = document.getElementById('interest-other-field'),
        interestOtherLabel = document.getElementById('interest-other-label'),
        dobMonth = document.getElementById('age-m'),
        hideFromFeb = document.querySelectorAll('.hideFromFeb');
        phoneNumber = document.getElementById('ut-tel'),
        disable = true;

assistiveYes.addEventListener('change', function(){
    if (this.value == "Yes"){
        assistiveTextarea.removeAttribute('disabled');
        assistiveLabel.classList.remove('disabled');
        assistiveTextarea.focus();
    } 
})

assistiveNo.addEventListener('change', function(){
    if (this.value == "No"){
        assistiveTextarea.setAttribute('disabled', true);
        assistiveLabel.classList.add('disabled');
    } 
})

interestOther.addEventListener('change', function(){
    if (this.checked === true){
        interestOtherfield.removeAttribute('disabled');
        interestOtherLabel.classList.remove('disabled');
        interestOtherfield.focus();
    } else {
        interestOtherfield.setAttribute('disabled', true);
        interestOtherLabel.classList.add('disabled');
    }
})

phoneNumber.addEventListener('blur', function (e) {
    this.value = this.value.replace(/[^\d() -]/g, '');
    if (this.value.length === 1 && (this.value === '1' || this.value === '0')) {
        this.value = '';
        disable = true;
    } else if (this.value.length === 2 && (this.value === '(1' || this.value === '(0')) {
        this.value = '(';
        disable = true;
    } else if (this.value.length > 9) {
        const x = ('' + this.value).replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})([a-zA-Z0-9]*)$/);
        if (x) {
            this.setAttribute('aria-hidden', 'true');
            this.value = '(' + x[1] + ') ' + x[2] + '-' + x[3];
            disable = false;
            setTimeout( () => {
                this.removeAttribute('aria-hidden');
            }, 1000);
        }
        else {
            disable = true;
        }
    }
    document.getElementById('contact-phone').disabled = disable;
    if (disable) {
        document.getElementById('contact-phone').checked = false;
        document.getElementById('contact-email').checked = true;
    }
});


dobMonth.addEventListener('change', function(){
    
    if(this.value == "February"){
        hideFromFeb.forEach(e => {
            e.style.display = "none";
        });
    } else {
        hidefromFeb.forEach(e => {
            e.style.display = "";
        });
    }
})

const utForm = document.getElementById('ut-form'), // Get entire form
      utSubmit = document.getElementById('ut-submit'), // Get submit btn
      allCheckboxes = document.querySelectorAll('input[type=radio], input[type=checkbox]'); // Get all radios & checkboxes

// Listen for 'enter' keydown on form in general & make sure it doesn't inadvertently trigger a submit
utForm.addEventListener('keydown', (e) => { 
    if (e.key === 'Enter') { 
        if (document.activeElement !== utSubmit && document.activeElement !== assistiveTextarea) {
            e.preventDefault();
        }
    }
});

// Listen for 'enter' keydown on radios & checks, then trigger toggles & change events
[...allCheckboxes].forEach((checkbox) => {
    const event = new Event('change');
    checkbox.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            if (document.activeElement.getAttribute('type') === 'checkbox' || (document.activeElement.getAttribute('type') === 'radio' && !checkbox.checked)) {
                e.preventDefault();
                checkbox.checked = !checkbox.checked;
                checkbox.dispatchEvent(event);
            } 
        }
    });
});

// slidey labels
window.addEventListener('load', function () {
    const slideLabels = document.querySelectorAll('.input-group > input');

    for (let i = 0; i < slideLabels.length; i++) {
        const e = slideLabels[i];
        styleLabel(e);
        e.addEventListener('input', function(){
            styleLabel(e);
        });
    }

    function styleLabel(e){
        const txt = e.value;
        if(txt){
            e.parentElement.classList.add('input-group-valid');
        } else {
            e.parentElement.classList.remove('input-group-valid');
        }
    }
});